<div style="height: 330px; width:600px;overflow:hidden" 
leaflet [leafletOptions]="options">
</div>